import React from "react";
import AccessDenied from "./AccessDenied";
import { useUserContext } from "../GestionDeUsuarios/UserContext";

const RequirePermission = ({ permission, permissions, message, children }) => {
  const { can, permissionsLoading } = useUserContext();
  const required = permissions || (permission ? [permission] : []);
  const allowed = required.length === 0 || required.some((perm) => can(perm));

  if (permissionsLoading) {
    return <div style={{ padding: "1.5rem" }}>Cargando permisos...</div>;
  }

  if (!allowed) {
    return (
      <AccessDenied
        message={message || "No tienes permiso para acceder a esta seccion."}
      />
    );
  }

  return children;
};

export default RequirePermission;
